export default __webpack_public_path__ + "static/media/mobile-bg.f47eec97.webp";